module.exports = __webpack_public_path__ + "img/xuyingjia.897dc9fb.jpg";